<template>
<div class="navigation-back flex-none">
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                outlined
                class="drei_60-btn"
                @click="navigateBack"
                v-bind="$attrs"
                style="width: 100%;"
            >
                {{ text }}
            </v-btn>
        </template>
        <div class="max-width-btn">
            <span>{{ tooltip }}</span>
        </div>
    </v-tooltip>
</div>
</template>

<script>

export default {
    name: 'NavigationBack',
    props: ['text', 'tooltip'],
    inheritAttrs: false,
    methods: {
        navigateBack() {
            this.$router.back();
        },
    },
};

</script>

<style lang="scss" scoped>
    .navigation-back {
        width: 100%;
    }
</style>
